import bugsnag from '@bugsnag/js'

const bugsnagClient = bugsnag({
  apiKey: '20279498356596aeb6ee1ce830653e16',
  releaseStage: 'production',
  notifyReleaseStages: [ 'development', 'production' ]
})

export default bugsnagClient